/**
* @des 最大限制解密公共方法
*
*/
import store from '@/public/store'
import router from '@/layout/router'
import { AXIOS } from './common-api'

import { http } from './http'

import DecryptPlugin from './decrypt-plugin'

import { INNER } from '../components/kye-canvas-table/mixins/calculate'

let cacheMaxDecrypt = {}

// 生成最大解密时的统一前缀key
export const createKeys = (key) => {
  const keyDecryptOrder = `${INNER}${key}DecryptOrder`
  const keyOriginValue = `${INNER}${key}OriginValue`
  const keyOriginMask = `${INNER}${key}OriginMask`
  return {
    keyDecryptOrder, // 解密的顺序
    keyOriginValue, // 原值
    keyOriginMask // 加密的密文
  }
}

// 设置内部解密字段
export const setInnerKey = (key, markrow, order, bizId, id) => {
  const {
    keyDecryptOrder,
    keyOriginValue,
    keyOriginMask,
  } = createKeys(key)

  const obj = {
    [keyDecryptOrder]: order,
    [keyOriginValue]: JSON.parse(JSON.stringify(markrow[key])),
    [keyOriginMask]: markrow[`${key}Mask`],
  }

  Object.assign(markrow, obj)

  const innerBizId = `${INNER}${bizId}`

  markrow[innerBizId] = markrow[bizId] || id
}

const processingReduceList = (reduceList, key, bizId) => {
  if (!key || !bizId) {
    return
  }
  const { keyDecryptOrder, keyOriginValue, keyOriginMask } = createKeys(key)
  reduceList && Array.isArray(reduceList) && reduceList.forEach(item => {
    // 还原
    item[key] = item[keyOriginValue]
    item[`${key}Mask`] = item[keyOriginMask]
    delete item[keyDecryptOrder] // 删除第一个解密的值

    // 删除对应的批量解密缓存的数据
    const innerBizId = `${INNER}${bizId}`

    // menuId
    const menu = store && store.getters && store.getters.menus && store.getters.menus[router.currentRoute.meta.tag]
    const menuId = menu && menu.id
    DecryptPlugin.removeCacheItem(menuId, item[innerBizId], key)
  })
}

// 处理最大限制的解密过程
export const procesingMaxDecrypt = (config, flatData, markrow, key, options, id) => {
  try {
    if (config && config[key]) {
      const { keyDecryptOrder } = createKeys(key)

      // 取当前__inner_order_order_【key】的值 如果不存在就是0
      const keyDecryptOrderList = flatData.filter(x => x.hasOwnProperty(keyDecryptOrder)).map(x => x[keyDecryptOrder])
      let order = keyDecryptOrderList.length ? Math.max(...keyDecryptOrderList) : 0

      const bizId = options.bizIdKey || 'id'

      // 如果存在内部变量就不再设置了, 批量解密已经生成了
      if (!markrow.hasOwnProperty(keyDecryptOrder)) {
        setInnerKey(key, markrow, ++order, bizId, id)
      }
      const orderList = flatData.filter(ele => ele.hasOwnProperty(keyDecryptOrder)) || []

      // 如果超出存在则下一步还原
      let reduceList = checkDecryptConf(config[key], keyDecryptOrder, orderList)
      // 还原
      processingReduceList(reduceList, key, bizId)
    }
  } catch (error) {
    return false
  }
}

// 检查单个key中的配置是否超出
export const checkDecryptConf = (max, key, orderList) => {
  max = (+max)
  if (!max) {
    return
  }
  if (orderList.length > max) {
    // 拿到order的值
    let orderValueList = orderList.map(ele => ele[key]).sort((a, b) => a - b) // 排序 保证顺序
    // 取超出的区间
    let diffList = orderValueList.slice(0, orderValueList.length - max)
    // 匹配原数据
    let res = diffList.map(order => orderList.find(ele => ele[key] === order))
    return res
  }
}

// 批量检查是否超出
export const checkBatchDecryptConf = (config, flatData, bizId) => {
  // 根据配置检查是否超出
  if (!config && Object.prototype.toString.call(config) !== '[object Object]') {
    return
  }
  const configKeys = Object.keys(config)
  // 遍历配置
  configKeys.forEach(k => {
    // 生成对应的order+key
    const { keyDecryptOrder } = createKeys(k)
    // 匹配数据
    const orderList = flatData.filter(ele => ele.hasOwnProperty(keyDecryptOrder)) || []
    // 检查是否存在数据
    let reduceList = checkDecryptConf(config[k], keyDecryptOrder, orderList)
    // 还原
    processingReduceList(reduceList, k, bizId)
  })
}

/**
 *
 * @description 获取最大解密条数配置
 * @export
 * @param {*} menuId 菜单ID
 * @return {*}
 */
 export function queryCurrentMenuIdDecryptConfig (menuId) {
  try {
    const menuResourcesId = menuId || window.__ERPMODULE__.id || ''
    // 如果不存在菜单ID和用户ID以及存在配置则直接返回配置
    if (!menuResourcesId) {
      return Promise.reject(new Error('参数错误'))
    }
    const currentMenuConfig = getCurrentMenuConfig(menuResourcesId)
    if (currentMenuConfig) {
      return Promise.resolve(currentMenuConfig || {})
    }
    return cacheMaxDecrypt[menuResourcesId] = http('auth.business.allotDecryptNumber.list', { menuResourcesId }, { ...AXIOS, log: false, cancel: true, appkey: 10132 }).then(res => {
      if (res) {
        cacheMaxDecrypt[menuResourcesId] = res
      }
      return cacheMaxDecrypt[menuResourcesId]
    })
  } catch (error) {
    console.log(error)
  }
}

export function getCurrentMenuConfig (menuId) {
  return cacheMaxDecrypt && cacheMaxDecrypt[menuId]
}



// WEBPACK FOOTER //
// ./src/public/utils/decrypt-max-plugin.js